export default {
  SHOW_TASK_HEADER: '@@task-wrapper/SHOW_TASK_HEADER',
  HIDE_TASK_HEADER: '@@task-wrapper/HIDE_TASK_HEADER',
};
